import { useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { DATE_RANGE_FILTER_KEYS } from '@/utils/filterFields';
import type { PendingSummarySearch } from '../types/pendingSummary.types';

const route = getRouteApi('/_auth/dashboards/pending');

function toFilterValues(search: PendingSummarySearch): Record<string, string> {
  return { dateFrom: search.dateFrom ?? '', dateTo: search.dateTo ?? '' };
}

function toFilterSearch(values: Record<string, string>): PendingSummarySearch {
  return { dateFrom: values.dateFrom || undefined, dateTo: values.dateTo || undefined };
}

export function usePendingSummaryFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const appliedValues = useMemo(() => toFilterValues(search), [search]);

  const filters = useUrlSyncedFilters({
    appliedValues,
    shouldWaitForApply: true,
    rangeKeys: DATE_RANGE_FILTER_KEYS,
    onApply: (values) => {
      void navigate({ search: toFilterSearch(values), replace: true });
    },
  });

  return { ...filters, search };
}
